export default __webpack_public_path__ + "static/media/Badoo_2_lowdef.150380bc.png";